import { Button, Form, Input, Modal, Result } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import { Usuario } from "../../perfil";

export const ModalSenhaTri7 = ({ visible, onCancel }) => {
  const [form] = useForm();

  const [erro, setErro] = useState(null);
  const [sucess, setSucess] = useState(false);
  const [loading, setLoading] = useState(false);

  const alterarSenhaTri7 = async (values) => {
    setErro(null);
    setSucess(false);
    setLoading(true);

    try {
      const response = await Usuario.putAlterarSenhaTri7({
        senha_tri7: values.senha,
      });

      if (response.status === 200 || response.status === 201) {
        setSucess(true);
      }
    } catch (error) {
      setErro(error.response ? error.response.data : "Erro desconhecido");
    } finally {
      setLoading(false);
    }
  };

  const getMensagemErro = () => {
    if (!erro) {
      return null;
    }

    if (typeof erro === "string") {
      return erro;
    }

    if (erro.senha) {
      return Array.isArray(erro.senha) ? erro.senha[0] : erro.senha;
    }

    if (erro.detail) {
      return erro.detail;
    }

    return "Opa, ocorreu um erro!";
  };

  useEffect(() => {
    setSucess(false);
    setErro(null);
    setLoading(false);
    form.resetFields();
  }, [visible, form]);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title="Alterar Senha Tri7"
      footer={null}
    >
      {sucess ? (
        <Result
          status="success"
          title="Senha Tri7 alterada com sucesso!"
          extra={[
            <Button type="primary" onClick={onCancel}>
              Fechar
            </Button>,
          ]}
        />
      ) : (
        <Form form={form} onFinish={alterarSenhaTri7} layout="vertical">
          <Form.Item
            name="senha"
            label={
              <text style={{ fontWeight: "600", fontSize: 14 }}>Senha Tri7:</text>
            }
            rules={[
              { required: true, message: "Informe a Senha Tri7." },
              {
                pattern: /^[a-zA-Z0-9]+$/,
                message:
                  "Informe apenas caracteres alfanuméricos (letras e números).",
              },
            ]}
          >
            <Input.Password style={{ width: "100%", borderRadius: 4 }} />
          </Form.Item>

          <Form.Item
            name="confirmarSenha"
            label={
              <text style={{ fontWeight: "600", fontSize: 14 }}>
                Confirmar Senha Tri7:
              </text>
            }
            dependencies={["senha"]}
            rules={[
              { required: true, message: "Confirme a Senha Tri7." },
              {
                pattern: /^[a-zA-Z0-9]+$/,
                message:
                  "Informe apenas caracteres alfanuméricos (letras e números).",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("senha") === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error("As senhas devem ser iguais.")
                  );
                },
              }),
            ]}
          >
            <Input.Password style={{ width: "100%", borderRadius: 4 }} />
          </Form.Item>
          <div style={{ marginBottom: 10 }}>
            <text style={{ fontSize: 12, color: "#ff0b0b" }}>
              Observação: informe apenas caracteres alfanuméricos, sem caracteres especiais.
            </text>
          </div>
          {erro ? <text style={{ color: "#ff3333" }}>{getMensagemErro()}</text> : null}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "40%",
              }}
            >
              <Button onClick={onCancel}>Cancelar</Button>
              <Button htmlType="submit" type="primary" loading={loading}>
                Confirmar
              </Button>
            </div>
          </div>
        </Form>
      )}
    </Modal>
  );
};
